import { useMemo, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { NEW_GROUP_ID } from '../../common/constants';
import { useIsLastGroupSubscriber, useIsNewestGroupSubscriber } from '../../services/store';
import useGetTicketTypesByGroup from '../get-ticket-types-by-group';
import useToggleState from '../toggle-state';

type Features = {
	hasReorder: boolean;
	hasRemove: boolean;
	hasOpen: boolean;
	hasCreateToolbar: boolean;
	canOpen: boolean;
	isOpen: boolean;
	toggleOpen: () => void;
};

const useGroupFeatures = (groupId: number): Features => {
	const [isSoleGroup] = useIsLastGroupSubscriber();
	const [isNewestGroup] = useIsNewestGroupSubscriber(groupId);
	const ticketTypes = useGetTicketTypesByGroup(groupId);

	const isCreateMode = groupId === NEW_GROUP_ID;
	const hasTicketTypes = !isEmpty(ticketTypes);

	const [isOpen, toggleOpen] = useToggleState(isCreateMode || isNewestGroup);

	useEffect(() => {
		if (ticketTypes && ticketTypes.length === 0 && !isOpen) {
			toggleOpen();
		}
	}, [isOpen, ticketTypes, toggleOpen]);

	return useMemo<Features>(
		(): Features => ({
			hasReorder: !isSoleGroup,
			hasRemove: !isCreateMode,
			hasOpen: !isCreateMode,
			hasCreateToolbar: isCreateMode,
			canOpen: !isCreateMode && hasTicketTypes,
			isOpen,
			toggleOpen,
		}),
		[hasTicketTypes, isCreateMode, isOpen, isSoleGroup, toggleOpen],
	);
};

export default useGroupFeatures;
